module.exports = __webpack_public_path__ + "static/img/music_danqu.0866a07e.png";